import React, { useState, useEffect } from "react";
import InputWithLabel from "./InputWithLabel";
import Button from "../buttons/button";
import SelectBox from "./SelectBox ";
import { useGetWorkingAreasQuery } from "../../../app/globalApi";
import moment from "moment";
import { useLocation } from "react-router-dom";
import { capitalize } from "../../../helpers/Utils";
import useTranslator from "../../../hooks/useTranslator";

const initialFormData = {
  employee_name: "",
  employee_doj: "",
  employee_role_id: "",
  attendance_status: "",
};

const today = moment().format("YYYY-MM-DD");

const StaffAttendanceFilter = ({
  onApplyFilter,
  date,
  onClose,
  filters = {},
}) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  let activeTab = searchParams.get("activeTab") ?? 8;
  const [filtersData, setFiltersData] = useState(initialFormData);
  const [roleList, setRoleList] = useState([]);
  const { data: workingAreas } = useGetWorkingAreasQuery();
  const { _t } = useTranslator();
  const attendanceStatus = [
    {
      label: _t("status_present", "Present"),
      value: "present",
    },
    {
      label: _t("status_absent", "Absent"),
      value: "absent",
    },
    {
      label: _t("status_pending", "Pending"),
      value: "pending",
    },
  ];

  useEffect(() => {
    if (workingAreas !== "") {
      if (activeTab) {
        const selectedArea = workingAreas?.data?.find(
          (area) => area.id === parseInt(activeTab)
        );
        const filteredRoles = selectedArea ? selectedArea.roles : [];
        setRoleList(filteredRoles);
      } else {
        setRoleList([]);
      }
    }
  }, [workingAreas, activeTab]);

  useEffect(() => {
    setFiltersData((prev) => ({
      ...prev,
      ...filters,
    }));
  }, [filters]);

  const handleChange = (e) => {
    setFiltersData({ ...filtersData, [e.target.name]: e.target.value });
  };

  const handleReset = (e) => {
    e.preventDefault();
    setFiltersData(initialFormData);
    onApplyFilter(initialFormData);
    if (onClose) {
      onClose();
    }
  };

  const handleApply = (e) => {
    e.preventDefault();
    onApplyFilter({ ...filtersData });
    if (onClose) {
      onClose();
    }
  };

  return (
    <div className="dropdown_body">
      <h5 className="mb-3 border-bottom">{_t("filter_heading", "Filter")}</h5>

      <InputWithLabel
        label={_t("employee_name", "Employee Name")}
        type="text"
        name="employee_name"
        value={filtersData.employee_name}
        onChange={handleChange}
        placeholder={_t("employee_name_placeholder", "Employee Name...")}
      />
      <InputWithLabel
        label={_t("employee_doj", "Date of Join")}
        type="date"
        name="employee_doj"
        value={filtersData.employee_doj}
        onChange={handleChange}
        max={today}
      />
      <SelectBox
        label={_t("attendance_status", "Status")}
        name="attendance_status"
        value={filtersData.attendance_status}
        onChange={handleChange}
        options={attendanceStatus?.map((list) => ({
          value: list.value,
          label: _t(list.label, list.label),
        }))}
      />
      <SelectBox
        label={_t("employee_role", "Role")}
        name="employee_role_id"
        value={filtersData.employee_role_id}
        onChange={handleChange}
        options={roleList?.map((list) => ({
          value: list.id,
          label: _t(capitalize(list.name), capitalize(list.name)),
        }))}
        disabled={activeTab === ""}
      />
      <div className="d-flex justify-content-between mt-3">
        <Button
          onClick={handleReset}
          label={_t("reset_button", "Reset")}
          className="reset_btn"
        />
        <Button
          className="cmn_btn"
          label={_t("apply_button", "Apply")}
          onClick={handleApply}
        />
      </div>
    </div>
  );
};

export default StaffAttendanceFilter;
